import type { PointerEvent } from "react";
import { useSelector } from "@tanstack/react-store";
import type { GridController } from "../../focus/gridController";
import { useColumnDrag } from "./dragContext";

/**
 * A header's drag bindings under `columnReorder`: pressing it starts a
 * column drag, and the dragged header marks itself. Display columns never
 * drag.
 */
export const useHeaderDragProps = ({
    controller,
    columnId,
    isDisplayHeader,
}: {
    controller: GridController;
    columnId: string;
    isDisplayHeader: boolean;
}) => {
    const columnDrag = useColumnDrag();
    const isDragSource = useSelector(
        controller.dragSource,
        (source) => source?.kind === "column" && source.id === columnId,
    );
    if (!columnDrag || isDisplayHeader) {
        return {};
    }
    return {
        "data-draggable": true,
        "data-drag-source": isDragSource || undefined,
        onPointerDown: (event: PointerEvent<HTMLElement>) =>
            columnDrag.startColumnDrag(event, columnId),
    };
};
